import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface DiscrepancyReport {
  id: string;
  reported_by_name: string | null;
  reported_at: string;
  reported_amount: number;
}

export const useDiscrepancyReports = (monitoringId?: string, productSku?: string) => {
  return useQuery({
    queryKey: ['discrepancy-reports', monitoringId, productSku],
    queryFn: async () => {
      let query = (supabase as any)
        .from('stock_discrepancy_reports')
        .select('id, reported_by_name, reported_at, reported_amount')
        .order('reported_at', { ascending: true });
      
      if (monitoringId) {
        query = query.eq('monitoring_id', monitoringId);
      } else if (productSku) {
        query = query.eq('product_sku', productSku);
      }
      
      const { data, error } = await query;
      if (error) throw error;
      return (data || []) as DiscrepancyReport[];
    },
    enabled: !!(monitoringId || productSku),
  });
};
